import React, { useEffect, useState } from "react";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import OutletDetail from "./outletDetail/outletDetail";
import { getOutlet } from "../../../../services/sales/outletService";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function OutletSetting({ match, history }) {
  const { reload } = useGlobalData();
  const outletID = match.params.outletID;
  const [outlet, setOutlet] = useState({});

  useEffect(() => {
    if (outletID > 0) {
      getOutletData(outletID);
    }
  }, [outletID, reload]);

  async function getOutletData(outletID = 0) {
    if (outletID > 0) {
      const response = await getOutlet(outletID);
      const { data } = response.data;
      setOutlet(data.outlet);
    }
  }

  const [headerTitle, setHeaderTitle] = useState("Outlet Info");
  const [actionButton, setActionButton] = useState([
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/sales/outlets");
      },
    },
  ]);
  return (
    <React.Fragment>
      <PageSubHeader
        title={headerTitle}
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/outlets",
            title: "Outlets",
            active: false,
          },
          {
            page: "/sales/outlet-setting/" + outletID,
            title: `Point of Sales Setting Outlet ID ${outletID} ${outlet.outletName}`,
            active: true,
          },
        ]}
        actionButtons={actionButton}
      />
      <OutletDetail
        outletID={outletID}
        appCode="OUTL"
        setHeaderTitle={setHeaderTitle}
        setActionButton={setActionButton}
        actionButton={actionButton}
        history={history}
      />
    </React.Fragment>
  );
}

export default OutletSetting;
